module.exports = __webpack_public_path__ + "img/1F1F0-1F1EA.3bb7a942.svg";